export default __webpack_public_path__ + "static/media/deftstabs3.8c9e93c4.png";